export default __webpack_public_path__ + "static/media/hhs-qld-south-west.04cdbcad.svg";